import React from "react";
import { Link, Route } from "react-router-dom";
import { AUTH_LEVELS } from "../lib/globals";

import HomePage, { loader as HomePageLoader } from "../pages/Index/HomePage";
import RequireAuth from "../components/RequireAuth";
import NotFound from "../components/NotFound";
import Contact from "../pages/Index/Contact";
import Rules, { loader as RulesLoader } from "../pages/Index/Rules";
import Login from "../pages/Index/Login";
import LostPassword, {
    action as LostPasswordAction,
} from "../pages/Index/LostPassword";
import ResetPassword, {
    loader as ResetPasswordLoader,
} from "../pages/Index/ResetPassword";
import Register, { loader as RegisterLoader } from "../pages/Index/Register";
import Profile, { loader as ProfileLoader } from "../pages/Index/Profile";
import { IUserProfileData } from "../types/forms";

export default (
    <Route>
        <Route
            index
            element={<HomePage />}
            loader={HomePageLoader}
            handle={{ noHeader: true }}
        />
        <Route
            path="/contact"
            element={<Contact />}
            handle={{
                crumb: () => <Link to="/contact">Contact UmpHub.net</Link>,
                header: () => "Contact UmpHub.net",
            }}
        />
        <Route path="/rules" handle={{ crumb: () => "Rules" }}>
            <Route
                path="majorybl"
                element={<Rules />}
                loader={params =>
                    RulesLoader({
                        ...params,
                        content: "majorybl_rules_page_content",
                    })
                }
                handle={{
                    crumb: () => (
                        <Link to="/rules/majorybl">MAJOR YBL Rules</Link>
                    ),
                    header: () => "MAJORYBL Rules",
                }}
            />
            <Route
                path="majorhighschool"
                element={<Rules />}
                loader={params =>
                    RulesLoader({
                        ...params,
                        content: "majorybl_highschool_rules_page_content",
                    })
                }
                handle={{
                    crumb: () => (
                        <Link to="/rules/majorhighschool">
                            MAJOR High School Rules
                        </Link>
                    ),
                    header: () => "MAJOR High School Rules",
                }}
            />
            <Route
                path="wisconsin-baseball-tournaments"
                element={<Rules />}
                loader={params =>
                    RulesLoader({
                        ...params,
                        content: "wibb_rules",
                    })
                }
                handle={{
                    crumb: () => (
                        <Link to="/rules/wisconsin-baseball-tournaments">
                            Wisconsin Baseball Tournaments Rules
                        </Link>
                    ),
                    header: () => "Wisconsin Baseball Tournaments Rules",
                }}
            />
            <Route
                path="illinois-baseball-tournaments"
                element={<Rules />}
                loader={params =>
                    RulesLoader({
                        ...params,
                        content: "ilbb_rules",
                    })
                }
                handle={{
                    crumb: () => (
                        <Link to="/rules/illinois-baseball-tournaments">
                            Illinois Baseball Tournaments
                        </Link>
                    ),
                    header: () => "Illinois Baseball Tournaments",
                }}
            />
        </Route>
        <Route
            path="login"
            element={<Login />}
            handle={{
                crumb: () => <Link to="/login">Login</Link>,
                header: () => "Login",
            }}
        />
        <Route
            path="lost-password"
            element={<LostPassword />}
            action={LostPasswordAction}
            handle={{
                crumb: () => <Link to="/lost-password">Lost Password</Link>,
                header: () => "Lost Password",
            }}
        />
        <Route
            path="reset-password"
            element={<ResetPassword />}
            loader={ResetPasswordLoader}
            handle={{
                crumb: () => <Link to="/reset-password">Reset Password</Link>,
                header: () => "Reset Password",
            }}
        />
        <Route
            path="register"
            element={<Register />}
            loader={RegisterLoader}
            handle={{
                crumb: () => {
                    return <Link to={`/register`}>Umpire Registration</Link>;
                },
                header: () => "Umpire Registration",
            }}
        />
        <Route element={<RequireAuth allowedUserLevels={AUTH_LEVELS.all} />}>
            <Route
                path="profile"
                element={<Profile />}
                loader={ProfileLoader}
                handle={{
                    crumb: () => <Link to="profile">My Profile</Link>,
                    header: () => "My Profile",
                }}
            />
        </Route>
        <Route
            element={
                <RequireAuth allowedUserLevels={AUTH_LEVELS.sitemanagement} />
            }
        >
            <Route
                path="profile/:userId"
                element={<Profile />}
                loader={ProfileLoader}
                handle={{
                    crumb: (data: IUserProfileData) => (
                        <Link to={`profile/${data.id}`}>Edit User Profile</Link>
                    ),
                }}
            />
        </Route>
        <Route path="*" element={<NotFound parent="index" />} />
    </Route>
);
